import { render, staticRenderFns } from "./recyclingTrends.vue?vue&type=template&id=9596b1c6&scoped=true"
import script from "./recyclingTrends.vue?vue&type=script&lang=js"
export * from "./recyclingTrends.vue?vue&type=script&lang=js"
import style0 from "./recyclingTrends.vue?vue&type=style&index=0&id=9596b1c6&prod&lang=less&scoped=true"
import style1 from "./recyclingTrends.vue?vue&type=style&index=1&id=9596b1c6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9596b1c6",
  null
  
)

export default component.exports